module.exports = __webpack_public_path__ + "img/Weapon_25.ccd59c9e.png";